import { Text } from "@dropbox/dig-components/typography";
import i18n from "@mirage/translations";
import { memo } from "react";

export const PromptsTab = memo(() => {
  return (
    <div>
      <div style={{ padding: "40px", textAlign: "center" }}>
        <Text size="large" color="subtle">
          {i18n.t("ai_tool_library_prompts")}
          {/* Handled in OTCA-723 and sits behind dash_2025_06_25_assist_ai_tool_library_prompts */}
        </Text>
      </div>
    </div>
  );
});

PromptsTab.displayName = "PromptsTab";
